import "./widgetSm.css";
import { useGetAllCustomersQuery } from "../../../services/userCRUDApi";
import userAfatar from "../../../images/femaleAfatar.png";
import { useNavigate } from "react-router-dom";
import { PeopleAltOutlined } from "@mui/icons-material";
import { AdminTable, AdminButton } from "../../../components/ui";

export default function WidgetSm() {
  const { data, isLoading } = useGetAllCustomersQuery();
  const navigate = useNavigate();

  const rows = (data?.results ?? []).slice(-5).reverse();

  const columns = [
    {
      key: "name",
      header: "Customer",
      render: (user) => (
        <div className="widgetSmUser">
          <img src={userAfatar} alt="" className="widgetSmImg" />
          <span>{user.first_Name} {user.last_Name}</span>
        </div>
      ),
    },
    { key: "phone_Number", header: "Phone" },
    {
      key: "actions",
      header: "",
      align: "right",
      render: (user) => (
        <AdminButton size="sm" variant="secondary" onClick={() => navigate(`/admin/customer/edit/${user.id}`)}>
          View
        </AdminButton>
      ),
    },
  ];

  return (
    <div className="widgetSm">
      <h2 className="widgetSmTitle">New Customers</h2>
      <AdminTable
        columns={columns}
        rows={rows}
        rowKey={(u) => u.id}
        isLoading={isLoading}
        pageSize={5}
        emptyIcon={<PeopleAltOutlined />}
        emptyTitle="No customers yet"
      />
    </div>
  );
}
